/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { memo } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Button from '@atlaskit/button/standard-button';
import __noop from '@atlaskit/ds-lib/noop';
var noop = __noop;
var itemWrapperStyles = css({
  display: 'flex',
  boxSizing: 'border-box',
  maxWidth: '100%',
  height: "".concat(24 / 14, "em"),
  margin: "var(--ds-space-0, 0px)",
  padding: "var(--ds-space-0, 0px)",
  flexDirection: 'row',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&:not(:last-child)::after': {
    width: "var(--ds-space-100, 8px)",
    flexShrink: 0,
    content: '"/"',
    paddingBlock: "var(--ds-space-025, 2px)",
    paddingInline: "var(--ds-space-100, 8px)",
    textAlign: 'center'
  }
});
var staticItemStyles = css({
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  paddingBlock: "var(--ds-space-025, 2px)"
});
var EllipsisItem = /*#__PURE__*/memo(function (props) {
  var _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? noop : _props$onClick,
    testId = props.testId,
    label = props.label;
  return jsx("li", {
    css: itemWrapperStyles
  }, jsx(Button, {
    appearance: "subtle-link",
    spacing: "none",
    testId: testId,
    onClick: onClick,
    "aria-label": label,
    css: staticItemStyles
  }, "\u2026"));
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default EllipsisItem;